import React from "react";
import { Box, Container, Typography, Stack } from "@mui/material";

const keywords = [
    "act out",
    "resilient",
    "calm",
    "connection",
    "joy",
    "kindness",
    "gratitude",
    "empathy",
    "science",
    "parenting",
    "emotional intelligence",
    "tools",
    "rituals",
    "connections",
    "warmth",
    "laughter",
    "love",
];

function boldKeywords(text) {
    const sortedKeywords = [...keywords].sort((a, b) => b.length - a.length);
    let result = text;
    sortedKeywords.forEach((word) => {
        const regex = new RegExp(`\\b(${word})\\b`, "gi");
        result = result.replace(regex, `<strong>$1</strong>`);
    });
    return result;
}

export default function CaughtYourselfThinkingSection() {
    return (
        <Box sx={{ bgcolor: "custom.blue", py: 8 }}>
            <Container maxWidth="md">
                <Stack spacing={4} alignItems="center">
                    <Typography
                        variant="h4"
                        align="center"
                        sx={{
                            color: "text.primary",
                            fontWeight: 400,
                        }}
                    >
                        <strong>If You’ve Ever Caught Yourself Thinking…</strong>
                    </Typography>
                    <Stack spacing={2} alignItems="center">
                        <Typography
                            variant="body1"
                            align="center"
                            sx={{
                                fontSize: 18,
                                color: "text.secondary",
                                fontWeight: 400,
                            }}
                            component="div"
                        >
                            <div>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "Why does my child act out when they can’t find the right words?"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "How do I raise a resilient little human who doesn’t crumble when things get tough?"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "How can we bring more calm, connection, and joy into our crazy, busy days?"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "What’s the easiest way to teach kindness, gratitude, and empathy without another lecture"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "or screen-time bribe?"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "Can science actually make parenting feel lighter and more meaningful?"
                                            ),
                                        }}
                                    />
                                </p>
                                <p>
                                    <span
                                        style={{ color: "rgb(1, 1, 1)" }}
                                        dangerouslySetInnerHTML={{
                                            __html: boldKeywords(
                                                "Where can I find real, ready-to-use tools that bring emotional intelligence to life at home?"
                                            ),
                                        }}
                                    />
                                </p>
                            </div>
                        </Typography>
                        <Typography
                            variant="body1"
                            align="center"
                            sx={{
                                fontSize: 20,
                                color: "text.secondary",
                                fontWeight: 400,
                            }}
                            component="div"
                        >
                            <div>
                                <p>
                                    <span style={{ color: "rgb(255, 255, 255)" }}>
                                        <strong>Then this eBook was created with YOU in mind.</strong>
                                    </span>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>
                                        <br />
                                        Through <strong>simple, science-backed activities</strong>, you’ll see your child open up, grow resilient,
                                    </span>
                                </p>
                                <p>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>
                                        and start to express their feelings not just through words, but through warmth, laughter, and love.
                                    </span>
                                </p>
                                <p>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>
                                        <strong>
                                            Because parenting doesn’t need to be perfect.<br />
                                            It just needs to be <em>connected.</em>&nbsp;
                                        </strong>
                                    </span>
                                </p>
                            </div>
                        </Typography>
                        <Typography
                            variant="body1"
                            align="center"
                            sx={{
                                fontSize: 20,
                                color: "text.secondary",
                                fontWeight: 400,
                            }}
                            component="div"
                        >
                            <div>
                                <p>
                                    <span style={{ color: "rgb(255, 255, 255)" }}>
                                        <strong>
                                            That’s exactly what <em>Happy US</em> helps you build: 
                                        </strong>
                                    </span>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>&nbsp;</span>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>
                                         the simple tools, rituals,
                                    </span>
                                </p>
                                <p>
                                    <span style={{ color: "rgb(0, 0, 0)" }}>
                                        and connections that nurture that same warmth and resilience in your child.
                                    </span>
                                </p>
                            </div>
                        </Typography>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}